import React, { Component } from 'react'
import Config from '../Config'
import classnames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import Header from '../widgets/common/Header'
import Footer from '../widgets/common/Footer'
import Filter from '../widgets/Providers/Filter'
import Loading from '../widgets/Loading'
import ProvidersResultCard from '../widgets/Providers/ProvidersResultCard'
import { Grid, Col, Row } from 'react-flexbox-grid'
import { EmptyStateProviders } from '../assets/images'
import RBButton from '../controls/RBButton'
import { localize } from '../util/Localizer'
import PaginationStyles from '../styles/components/pagination'
import { getProviders } from '../redux/actions/providersActions'

let map
let marker
class Providers extends Component {
  constructor (props) {
    super(props)
    this.changeNext = this.changeNext.bind(this)
    this.changePrev = this.changePrev.bind(this)
    this.changePage = this.changePage.bind(this)
    this.state = {
      providerFilterContent: '',
      searchSize: 50,
      autocomplete: null,
      map: null,
      isloading: false,
      openInfoWindow: null,
      providers: null,
      filterKey: 0
    }
  }

  handleProviderFilterSearch = async (providerFilterContent) => {
    if (!providerFilterContent.filters) {
      this.setState(prevState => ({
        providers: null,
        filterKey: prevState.filterKey + 1
      }))
      map = null
    } else {
      this.setState(prevState => ({
        ...prevState,
        providerFilterContent: providerFilterContent,
        isloading: true
      }))
      try {
        const providersData = await getProviders(providerFilterContent, 1, this.state.searchSize)
        this.setState({
          isloading: false,
          providers: providersData
        }, () => {
          this.initMap()
        })
      } catch (error) {
        console.error('Failed to fetch providers:', error)
      }
    }
  }

  changeNext () {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    this.changePage(this.state.providers.pagingDetails.pageNumber + 1)
  }
  changePrev () {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    this.changePage(this.state.providers.pagingDetails.pageNumber - 1)
  }
  async changePage (number) {
    if (this.state.providers.pagingDetails.pageNumber !== number) {
      this.setState({ isloading: true })
      try {
        const providersData = await getProviders(this.state.providerFilterContent, number, this.state.searchSize)
        this.setState({
          isloading: false,
          providers: providersData
        }, () => {
          this.initMap()
        })
        marker.provider = this.state.providers.items[0]
      } catch (error) {
        console.error('Failed to fetch providers:', error)
      }
    }
  }

  renderPagination () {
    const { classes = {} } = this.props
    const self = this
    let total = this.state.providers.pagingDetails.totalPages
    let currentPage = this.state.providers.pagingDetails.pageNumber
    const buildPages = (pageNum, totalPages) => {
      let pages = Array.from({ length: totalPages }, (v, i) => ++i)

      if (totalPages > 9) {
        pages = pages.filter(page => {
          if (page === 1) { // first one
            return true
          } else if (page === totalPages) { // Last one
            return true
          } else if (page >= pageNum - 2 && page <= pageNum + 2) { // padding when in the middle
            return true
          } else { return false }
        })

        // Determine if ellipsis should be added before the last page number
        const lastPageToShow = pages[pages.length - 2] // Second to last item, before adding the last page
        if (lastPageToShow < totalPages - 1) {
          // If there's more than one page number gap before the last page, insert ellipsis
          pages.splice(pages.length - 1, 0, -1) // Insert -1 before the last page number
        }
      }

      if (pages.length > 3 && pages[1] !== 2) { // Adjust for the first ...
        pages.splice(1, 0, -1)
      }

      return pages
    }

    let pagination = buildPages(currentPage, total, [[1, 2, 3, -1, 24, 25]])
    return (
      <Col className={classes.pagination}>
        <RBButton label={localize('pages.ariaLabel.previous')} variant='outlined' disabled={currentPage === 1} onClick={this.changePrev} />

        <div className={classes.paginationButtons}>
          <ul>
            {pagination.map(function (number, index) {
              const key = number === -1 ? 'dot' + index : number
              var output = number === -1 || number === -5
                ? <li
                  key={key}
                  id={number}
                  className={classes.pageButton}
                >...</li>
                : <li
                  key={key}
                  id={number}
                  onClick={() => { self.changePage(number) }}
                  className={classnames(classes.pageButton, { active: number === currentPage })}
                >{number}</li>

              return output
            })
            }
          </ul>
        </div>
        <RBButton label={localize('pages.ariaLabel.next')} variant='outlined' disabled={this.state.providers.pagingDetails.pageNumber === total} onClick={this.changeNext} />
      </Col>
    )
  }

  renderResponsivePagination () {
    const { classes = {} } = this.props

    if (window.innerWidth < 1200) {
      return (
        <Col className={classnames(classes.responsivePagination, 'hidden-lg')} >
          <RBButton className='providerBtn' label={localize('pages.ariaLabel.previous')} variant='outlined' disabled={this.state.providers.pagingDetails.pageNumber === 1} onClick={this.changePrev} />
          <div >
            <p>{this.state.providers.pagingDetails.pageNumber} of {this.state.providers.pagingDetails.totalPages}</p>
          </div>
          <RBButton className='providerBtn' label={localize('pages.ariaLabel.next')} variant='outlined' disabled={this.state.providers.pagingDetails.pageNumber === this.state.providers.pagingDetails.totalPages} onClick={this.changeNext} />
        </Col>
      )
    }
  }

  loaderHandler = () => {
    return (
      <div className={classnames('loadingContainer')}>
        <Loading message={localize('pages.providers.search.loading')} />
      </div>
    )
  }

  initLoader = () => {
    const additionalOptions = {}
    const loader = new window.google.maps.plugins.loader.Loader({
      apiKey: Config.providers.searchKey,
      version: 'weekly',
      ...additionalOptions
    })

    loader.load().then(async () => {
      const map = await window.google.maps.importLibrary('maps')
      const auto = await window.google.maps.importLibrary('places')
      const marker = await window.google.maps.importLibrary('marker')
      this.setState(prevState => ({
        ...prevState,
        autocomplete: auto,
        map: map,
        marker: marker
      }))
    })
  }

  initMap = (lat = this.state.providerFilterContent.lat, lng = this.state.providerFilterContent.lng) => {
    this.setState(prevState => ({
      ...prevState,
      isloading: false
    }))

    const { Map } = this.state.map
    if (this.state.openInfoWindow) {
      this.state.openInfoWindow.close() // Close the currently open InfoWindow
    }

    let bounds = new window.google.maps.LatLngBounds()

    map = new Map(document.getElementById('map'), {
      center: { lat, lng },
      mapId: 'PROVIDERS_MAP'
    })

    const markers = this.state.providers.items.map((provider) => {
      const marker = new window.google.maps.marker.AdvancedMarkerElement({
        position: { lat: provider.address.latitude, lng: provider.address.longitude },
        map,
        gmpClickable: true
      })

      marker.addListener('click', () => {
        const infoWindow = new window.google.maps.InfoWindow({
          content: this.markerTooltip(provider)
        })
        if (this.state.openInfoWindow) {
          this.state.openInfoWindow.close() // Close the currently open InfoWindow
        }
        infoWindow.open(map, marker)
        this.setState({ openInfoWindow: infoWindow })
        map.setZoom(19)
      })

      bounds.extend({ lat: provider.address.latitude, lng: provider.address.longitude })

      return marker
    })

    // do not remove the commment below it's used by the build script
    /* global markerClusterer */
    new markerClusterer.MarkerClusterer({ markers, map })// eslint-disable-line

    map.fitBounds(bounds)

    map.addListener('click', () => {
      if (this.state.openInfoWindow) {
        this.state.openInfoWindow.close() // Close the currently open InfoWindow
      }
    })
  }

  markerTooltip = (provider) => {
    const address = encodeURIComponent(`${provider.address.addressLine1} ${provider.address.city} ${provider.address.postalCode} ${provider.address.country}`)
    const content = document.createElement('div')
    content.innerHTML = `
      <div class='markerTooltip'>
        <h4>${provider.name}</h4>
        <p>
          ${provider.address.addressLine1}
          <br/>
          ${provider.address.city}, ${provider.address.postalCode}
          <br/>
          ${provider.address.country}
        </p>
        <a target='_blank' href='https://www.google.com/maps/search/${address}'>View on google maps</a>
      </div>
      `
    return content.outerHTML
  }

  handleProviderResultClick = (provider) => {
    if (window.innerWidth < 767) {
      const address = encodeURIComponent(`${provider.address.addressLine1} ${provider.address.city} ${provider.address.postalCode} ${provider.address.country}`)
      window.open(`https://www.google.com/maps/search/${address}`, '_blank')
    } else {
      map.setCenter({ lat: provider.address.latitude, lng: provider.address.longitude })
      map.setZoom(19)
      // Close the InfoWindow if it's open
      if (this.state.openInfoWindow) {
        this.state.openInfoWindow.close()
        this.setState({ openInfoWindow: null }) // Reset the InfoWindow reference
      }

      const infoWindow = new window.google.maps.InfoWindow({
        content: this.markerTooltip(provider),
        position: { lat: provider.address.latitude, lng: provider.address.longitude },
        pixelOffset: new window.google.maps.Size(0, -40)
      })
      infoWindow.open(map)
      this.setState({ openInfoWindow: infoWindow })
    }
  }

  componentDidMount () {
    map = null
    this.initLoader()
  }

  render () {
    var ret = (
      <div className='pageContent'>
        <Header />
        <div className='providersHeadline'>
          <h4>{localize('common.header.providers')}</h4>
        </div>
        <Filter
          key={this.state.filterKey}
          className='providers'
          onProviderFilterSearch={this.handleProviderFilterSearch}
          autocomplete={this.state.autocomplete}/>
        <section className='mainContent providers'>
          <Grid className='providersContainer' fluid>
            {this.state.isloading && !map && this.loaderHandler()}
            {!this.state.providers
              ? (<Row style={{ display: 'flex', justifyContent: 'center', paddingTop: '20px' }}>
                {!this.state.isloading && <Col className='providersInitialInfo initial' sm={12} >
                  <EmptyStateProviders className='providerIcon' />
                  <h4 className='emptyProvidersEmpty'>{localize('pages.providers.search.find.title')}</h4>
                </Col>}
              </Row>
              ) : (<Row style={{ display: 'flex', justifyContent: 'center', paddingTop: '20px' }}>
                <Col className='providersInitialInfo results' xl={4} lg={6} md={12} sm={12} >
                  <h4 className='resultsTitle'>{localize('pages.providers.search.results.title')}</h4>
                  {this.state.isloading ? this.loaderHandler()
                    : <span style={{ width: '100%' }}>
                      {this.state.providers && (this.state.providers.items || []).length === 0
                        ? (<div className='noResults'>
                          <h5>{localize('pages.providers.search.noResults.title')}</h5>
                          <p>{localize('pages.providers.search.noResults.content')}</p>
                        </div>
                        ) : (this.state.providers.items.map((item, index) => (
                          <ProvidersResultCard
                            key={index}
                            providerData={item}
                            onClick={() => this.handleProviderResultClick(item)}
                          />
                        )))
                      }
                    </span>}
                </Col>
                <Col className='providersInitialInfo map' xl={4} lg={6} md={12} sm={12} >
                  {/* This is the div where the map is loaded */}
                  <div id='map' style={{ height: '100%', width: '100%' }}>
                  </div>
                </Col>
              </Row>
              )
            }
            {this.state.providers && (this.state.providers.items || []).length !== 0 && this.renderPagination()}
            {this.state.providers && (this.state.providers.items || []).length !== 0 && this.renderResponsivePagination()}
          </Grid>
          <Footer />
        </section>
      </div>
    )

    return ret
  }
}

const styles = {
  ...PaginationStyles
}

export default withStyles(styles)(Providers)



// WEBPACK FOOTER //
// ./src/components/Providers.js